import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastMessageService {
  static readonly COMMON_TOAST_KEY = 'common-toast';

  constructor(private readonly messageService: MessageService) {}

  showSuccess(message): any {
    this.messageService.add(message);
  }
  showError(message): any {
    this.messageService.add(message);
  }
  showWarn(message): any {
    this.messageService.add(message);
  }
}
